var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 108,
    viewBox: "0 0 104 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.2 14.4H20.8C16.9693 14.4 13.8667 17.622 13.8667 21.6V86.4C13.8667 90.378 16.9693 93.6 20.8 93.6H83.2C87.0307 93.6 90.1333 90.378 90.1333 86.4V21.6C90.1333 17.622 87.0307 14.4 83.2 14.4ZM37.9739 79.2H27.7472V45.0288H37.9739V79.2ZM32.7565 40.1436C29.4597 40.1436 26.7939 37.368 26.7939 33.9516C26.7939 30.5352 29.4632 27.7632 32.7565 27.7632C36.0429 27.7632 38.7157 30.5388 38.7157 33.9516C38.7157 37.368 36.0429 40.1436 32.7565 40.1436ZM76.2805 79.2H66.0608V62.5824C66.0608 58.6188 65.9915 53.5212 60.7464 53.5212C55.4251 53.5212 54.6069 57.8376 54.6069 62.2944V79.2H44.3872V45.0288H54.1979V49.698H54.3365C55.7024 47.0124 59.0373 44.1792 64.012 44.1792C74.3669 44.1792 76.2805 51.2568 76.2805 60.4584V79.2V79.2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.5e3198e60c904fa97684c33754376a0a.svg";
export { ForwardRef as ReactComponent };